import axios from 'axios'
import type { DCCastroomInfo } from '@dronecast/shared'
import { config } from '@/stores/dronecastStore'

const API_BASE_URL = '/dronecast/1.0'
const STORAGE_KEY = 'dronecast_user'

function getAuthHeaders(): Record<string, string> {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored) {
    try {
      const user = JSON.parse(stored)
      return { 'x-api-key': user.apiKey, 'x-user-email': user.userEmail }
    } catch {}
  }
  return { 'x-api-key': config.server.apiKey, 'x-user-email': config.server.userEmail }
}

/**
 * Dronecast HTTP API 서비스
 *
 * Store에서 API 호출을 분리하여, Store는 순수 상태 컨테이너로 유지한다.
 */
export const dronecastApiService = {
  async fetchCastrooms(gcsId?: string): Promise<DCCastroomInfo[]> {
    const headers = getAuthHeaders()
    const url = gcsId
      ? `${API_BASE_URL}/castroom?gcsId=${gcsId}`
      : `${API_BASE_URL}/castroom`
    const response = await axios.get(url, { headers })
    return response.data.castRooms as DCCastroomInfo[]
  },

  async fetchCastroom(streamId: string): Promise<any> {
    const headers = getAuthHeaders()
    const response = await axios.get(`${API_BASE_URL}/castroom/${streamId}`, { headers })
    return response.data
  },
}
